import UKMap from './UKMap';
import Modal from './Modal';
import { isInViewport, doScrolling } from '../utils';
import Map from './Map';
import Table from './Table';

class App {
  constructor() {
    this.intro = document.querySelector('.intro-modal');
    this.about = document.getElementById('about');
    this.map = document.getElementById('map');
    this.fadeIns = document.querySelectorAll('.fade-in-view');
    this.findOutMore = document.querySelector('.find-out-more__button');
    this.mapUni = document.getElementById('map-uni');
    this.tableContainer = document.querySelector('.table-container');

    this.introModal = new Modal(this.intro, 'intro');
    this.aboutModal = new Modal(this.about, 'about');

    if (this.map) {
      this.ukMap = new UKMap(this.map);
    }

    if (this.mapUni) {
      this.uniMap = new Map(this.mapUni);
    }

    if (this.tableContainer) {
      this.table = new Table(this.tableContainer);
    }

    this.init();
  }

  init() {
    this.introModal.open();

    if (this.mapUni) {
      this.uniMap.init();
    }
    
    this.bindEventListeners();
  }

  bindEventListeners() {
    // scroll to content
    if (this.findOutMore) {
      this.findOutMore.addEventListener('click', (e) => {
        doScrolling('.content', 678);
      });
    }

    if(this.fadeIns.length > 0) {
      window.addEventListener('scroll', (e) => {
        for(let i = 0; i < this.fadeIns.length; i++) {
          if(isInViewport(this.fadeIns[i], true)) {
            this.fadeIns[i].classList.add('is-in-view');
          }
        }
      }, false);
    }
  }
}

export default App;